import {useState} from 'react';
import { Field, FieldProps } from 'formik';
import { validateCountArtist } from "./validate";
import classnames from 'classnames';

export function CountArtistInput() {
    const [showError, setShowError] = useState(false);

    const openShowError = () => {
        if (!showError) {
            setShowError(true);
        }
    }

    return (
        <Field name="countArtist" validate={validateCountArtist}>
            {(props: FieldProps) => {
                const { field, form: {isSubmitting}, meta: { error } } = props;
                
                if (isSubmitting) {
                    openShowError();
                }

                return (
                    <div>
                        <label htmlFor="countArtist" className="block mb-2 text-sm font-medium text-gray-900">Approx total artists onboarded with the gallery?</label>
                        <input
                            type="text"
                            className={
                                classnames(
                                    "bg-gray-50 border text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-1 focus:border w-full p-2.5",
                                    {
                                        "border-gray-300 focus:border-blue-500 focus:ring-blue-500": !(showError && error), 
                                        "border-red-500 focus:border-red-500 focus:ring-red-500": showError && error, 
                                    },
                                )
                            }
                            onKeyDown={(event) => {
                                if (event.key !== "Backspace" && !/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                            {...field}
                            onFocus={openShowError}
                        />
                        {showError && error && (
                            <p className="mt-1.5 text-xs text-red-600 dark:text-red-500">{error}</p>
                        )}
                    </div>
                );
            }}
        </Field>
    );
}